import React, { useEffect, useState } from 'react'
import { ReactComponent as Logo } from '@/shared/assets/logo_7blaze.svg'
import { ReactComponent as BurgerMenu } from '@/shared/assets/menu.svg'
import { ReactComponent as XMark } from '@/shared/assets/closeBtn.svg'
import { ReactComponent as Mail } from '@/shared/assets/mail.svg'
import { ReactComponent as Globe } from '@/shared/assets/globe.svg'
import { Navigation } from '../Navigation/Navigation'
import { Button } from '@/shared/ui/Button/Button'
import { useScrollDirection } from '@/shared/lib/hooks/useSrollDirection'
import { classNames } from '@/shared/lib/utils/classNames'
import { scrollIntoView } from '@/shared/lib/utils/scrollIntoView'
import useResize from '@/shared/lib/hooks/useResize'
import cls from './Header.module.scss'

export const Header = () => {
    const scrollDirection = useScrollDirection()
    const windowWidth = useResize()
    const [open, setOpen] = useState(false)
    const mobileHeader = () => {
        return (
            <>
                <header className={cls.MobileHeader}>
                    <Logo
                        onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })}
                        className={cls.Logo}
                    />
                    {open ? (
                        <XMark
                            onClick={() => setOpen(false)}
                            className={cls.BurgerMenu}
                        />
                    ) : (
                        <BurgerMenu
                            onClick={() => setOpen(true)}
                            className={cls.BurgerMenu}
                        />
                    )}
                </header>
                <menu
                    className={classNames(cls.MobileMenu, [], {
                        [cls.close]: !open,
                    })}
                >
                    <Navigation />
                    <Button
                        onClick={() => scrollIntoView('contact')}
                        variant="gradient"
                    >
                        Contact Us
                    </Button>

                    <aside className={cls.title}>
                        <div className={cls.mailText}>
                            <Mail className={cls.mailIcon} />
                            <p>distributors@stellar-bets.com</p>
                        </div>
                        <div className={cls.siteText}>
                            <Globe className={cls.globeIcon} />
                            <p>www.7-stellar.com</p>
                        </div>
                    </aside>
                </menu>
            </>
        )
    }
    const desktopHeader = () => {
        return (
            <header className={cls.DesktopHeader}>
                <div className={cls.container}>
                    <Logo
                        onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })}
                        className={cls.Logo}
                    />
                    <Navigation />
                    <Button
                        onClick={() => scrollIntoView('contact')}
                        variant="gradient"
                    >
                        Contact Us
                    </Button>
                </div>
            </header>
        )
    }

    useEffect(() => {
        const refFunc = () => {
            setOpen(false)
        }
        window.addEventListener('scroll', refFunc)

        return () => {
            window.removeEventListener('scroll', refFunc)
        }
    }, [])
    return (
        <div
            className={classNames(cls.wrapper, [], {
                [cls.hide]: scrollDirection === 'down',
            })}
        >
            {windowWidth >= 1024 ? desktopHeader() : mobileHeader()}
        </div>
    )
}
